import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {BlogsHttpService} from '../../../services/http-services/blogs/blogs-http.service';
import {GrPagination} from '../../../interfaces/general-interfaces';
import {GrBlog} from '../../../interfaces/blogs-interfaces';
import {BannersHttpService} from '../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../interfaces/banners-interfaces';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html'
})
export class BlogsComponent implements OnInit {
  blogs: GrBlog[] = [];
  featuredBlog: GrBlog | null = null;
  banner: GrBanner | null = null;
  blogsPagination!: GrPagination;
  urlParams: {page: number} = {
    page: 1
  };

  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;

  constructor(private blogsHttpService: BlogsHttpService,
              private bannersHttpService: BannersHttpService) {
  }

  ngOnInit(): void {
    this.getFeaturedBlogs();
    this.getBlogs();
    this.getBanner();
  }

  getBlogs(): void {
    this.urlParams.page = (this.blogsPagination?.currentPage) ? this.blogsPagination.currentPage : 1;
    this.blogsHttpService.getBlogsLanding(this.urlParams).then(blogsRes => {
      this.blogs = blogsRes.data;
    });
  }

  getFeaturedBlogs(): void {
    this.blogsHttpService.getBlogsFeatured().then(blogsRes => {
      this.featuredBlog = blogsRes;
    });
  }

  getBanner(): void {
    this.bannersHttpService.getLandingWebBanner({bannerType: 'e'}).then(res => {
      this.banner = res.data[0];
    });
  }
}
